import * as ActionTypes from './constants';

const createGUID = () => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  };

  return `${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}${s4()}`;
};

export const setGUID = () => {
  return { type: ActionTypes.SET_GUID, payload: createGUID() };
};

export const hideBranchesCta = () => {
  return { type: ActionTypes.HIDE_BRANCHES_CTA };
};
